import React from 'react';
import Device from '@core/scripts/components/device';
import {Breadcrumb} from "@bonprix/design-system";
import Landmark from "@core/scripts/components/landmark-adapter";

export default function BackToShop({breadcrumbs}) {
    if (!Device.isApp()) {
        const onClick = ({landmark}) => {
            Landmark.sendClickLandmark(landmark);
        };

        return (
            <div className="px-2 w-full">
                {breadcrumbs.map((breadcrumb, index) => (
                    <div className="hidden mt-2 mb-2 min-h-7 last:block" onClick={() => onClick(breadcrumb)}
                         key={`breadcrumb-${index}`}>
                        <Breadcrumb
                            hideHeader
                            previousPageTitle={breadcrumb.name}
                            previousPageUrl={breadcrumb.url}
                        />
                    </div>
                ))}
            </div>
        );
    }
}
